import { Component } from '@angular/core';

@Component({
  selector: 'app-search-button',
  standalone: true,
  imports: [],
  templateUrl: './search-button.component.html',
  styleUrl: './search-button.component.scss'
})
export class SearchButtonComponent {

}
